import React from 'react';
import { Empty, Form, Icon, Select, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import useRequestsDateModes from '../../../../../../queries/useRequestsDateModes';
import Btn from '../../../../../../components/btn';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import styles from './SelectDateMode.module.scss';

const selectValue = (state) => state.filterStore.dateRangeField;

const SelectDateMode = ({ onChange }) => {
  const { data, isFetching } = useRequestsDateModes();
  const filterCommands = useRequestFilterCommands();

  const value = useSelector(selectValue);

  const dispatch = useDispatch();

  const handleChange = (value) => {
    dispatch(filterCommands.setDateRangeField(value));

    if (typeof onChange === 'function') {
      onChange(value);
    }
  };

  const isError = data === 'Error' || data?.success === false;

  const options = Array.isArray(data?.dateModes) ? data.dateModes : undefined;

  const showValue =
    !isFetching && Array.isArray(data?.dateModes) && data.dateModes.length > 0;

  return (
    <Form.Item>
      <Select
        value={showValue ? value : undefined}
        onChange={handleChange}
        style={{ width: '100%' }}
        loading={isFetching}
        placeholder="Выберите режим даты"
        defaultActiveFirstOption={false}
        notFoundContent={isError ? <FetchErrorContent /> : undefined}
      >
        {options?.map(({ id, name }) => (
          <Select.Option
            key={id}
            value={id}
          >
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectDateMode;

const imageStyle = {
  height: 50,
  fontSize: 50,
};

const image = (
  <Icon
    type="exclamation-circle"
    className={styles.icon}
  />
);

function FetchErrorContent() {
  const { data } = useRequestsDateModes();

  return (
    <Empty
      image={image}
      imageStyle={imageStyle}
      description={
        <Typography.Text className={styles.description}>
          <Typography.Text>Не удалось загрузить типы дат.</Typography.Text>

          {Boolean(data?.message) && (
            <Typography.Text>{data.message}</Typography.Text>
          )}

          <br />

          <Typography.Text>
            Если это не первая попытка, обратитесь в службу поддержки
          </Typography.Text>
        </Typography.Text>
      }
    >
      <UpdateBtn />
    </Empty>
  );
}

function UpdateBtn() {
  const { isFetching, refetch } = useRequestsDateModes();

  return (
    <Btn
      onClick={refetch}
      disabled={isFetching}
      block
    >
      {isFetching ? <Icon type="loading" /> : 'Попробовать снова'}
    </Btn>
  );
}
